import { Col, Row } from 'reactstrap';
import { FooterWrapper } from './Footer.styled';
import { useMediaQuery } from 'react-responsive';


function Footer() {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
   <FooterWrapper>
      <div className="footer-section1">
         <div className="footer-nav-wrap">
            {isMobile ? (
                <Row>
                <Col xs={12} md={8} className="d-flex justify-content-center align-items-center text-center">
                   <ul>
                      <li>
                         <a href="/about" className="menu-link">About</a>
                      </li>
                      <li>
                         <a href="/disclaimer" className="menu-link">Disclaimer</a>
                      </li>
                      <li>
                         <a rel="privacy-policy" href="/privacy-policy" className="menu-link">Privacy Policy</a>
                      </li>
                   </ul>
                </Col>
                <Col xs={12} md={4} className="d-flex justify-content-center align-items-center text-center">
                   <ul>
                      <li>
                         <a href="http://facebook.com/misstechack/" title="Facebook">
                            <span className="fa fa-facebook"></span>
                         </a>
                      </li>
                      <li>
                         <a href="http://instagram.com/misstechack" title="Instagram">
                            <span className="fa fa-instagram"></span>
                         </a>
                      </li>
                      <li>
                         <a href="https://github.com/misstechack/Java-Tutorial" title="YouTube">
                            <span  className="fa fa-github"></span>
                         </a>
                      </li>
                      <li>
                         <a href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA" title="YouTube">
                            <span  className="fa fa-youtube"></span>
                         </a>
                      </li>
                   </ul>
                </Col>
             </Row>
            ) : (
               <Row>
               <Col xs={12} md={10}>
                  <ul>
                     <li>
                        <a href="/about" className="menu-link">About</a>
                     </li>
                     <li>
                        <a href="/disclaimer" className="menu-link">Disclaimer</a>
                     </li>
                     <li>
                        <a rel="privacy-policy" href="/privacy-policy" className="menu-link">Privacy Policy</a>
                     </li>
                  </ul>
               </Col>
               <Col xs={12} md={2} >
                  <ul className="align-items-right">
                     <li>
                        <a href="http://facebook.com/misstechack/" title="Facebook">
                           <span className="fa fa-facebook"></span>
                        </a>
                     </li>
                     <li>
                        <a href="http://instagram.com/misstechack" title="Instagram">
                           <span className="fa fa-instagram"></span>
                        </a>
                     </li>
                     <li>
                        <a href="https://github.com/misstechack/Java-Tutorial" title="YouTube">
                           <span  className="fa fa-github"></span>
                        </a>
                     </li>
                     <li>
                        <a href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA" title="YouTube">
                           <span  className="fa fa-youtube"></span>
                        </a>
                     </li>
                  </ul>
               </Col>
            </Row>
            )}
         </div>
      </div>
      <div className="footer-section2">
         <p style={{color: '#f0f5fa'}}>Copyright © 2026 Grow As You Learn</p>
      </div>
   </FooterWrapper>
  );
}

export default Footer;
